var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRoutalStarGreen = function SvgRoutalStarGreen(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.133789 6.80279C3.02596 6.80279 5.37129 9.14811 5.37129 12.0403C5.53505 12.2187 5.81577 12.2187 5.97661 12.0403C5.97661 9.14811 8.32194 6.80279 11.2141 6.80279C11.3925 6.63903 11.3925 6.35829 11.2141 6.19745C8.32194 6.19745 5.97661 3.85213 5.97661 0.95996C5.81285 0.781576 5.53213 0.781576 5.37129 0.95996C5.37129 3.85213 3.02596 6.19745 0.133789 6.19745C-0.0445957 6.36122 -0.0445957 6.64195 0.133789 6.80279Z",
    fill: "#406867"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRoutalStarGreen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "routal-star-green.8b979b759ecb022eff0cc54a81982e74.svg";